import './page/topdata-conversion-log-list';
import enGB from './snippet/en-GB';
import deDE from './snippet/de-DE';

const { Module } = Shopware;

Module.register('topdata-contact-login-conversion-log', {
    snippets: {
        'en-GB': enGB,
        'de-DE': deDE,
    },
    type: 'plugin',
    name: 'TopdataContactLoginSW6.conversionLog.module.name',
    title: 'TopdataContactLoginSW6.conversionLog.module.title',
    description: 'TopdataContactLoginSW6.conversionLog.module.description',
    color: '#ff5722',
    icon: 'regular:exchange',

    entity: 'tdcl_customer_conversion_log',

    routePrefixName: 'topdata.contact.login.conversion.log',
    routePrefixPath: 'topdata/contact/login/conversion/log',

    routes: {
        list: {
            component: 'topdata-conversion-log-list',
            path: 'list',
        },
    },

    navigation: [{
        id: 'topdata-contact-login-conversion-log',
        label: 'TopdataContactLoginSW6.conversionLog.module.title',
        color: '#ff5722',
        icon: 'regular:exchange',
        path: 'topdata.contact.login.conversion.log.list',
        parent: 'sw-customer',
        position: 130,
    }],
});
